/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EnsureEmailValidityWithSsoResult } from '../models/ensure-email-validity-with-sso-result';
import { GetRegistrationSiteResult } from '../models/get-registration-site-result';
import { GetRegistrationSitesResult } from '../models/get-registration-sites-result';
import { getSite } from '../fn/registration/get-site';
import { GetSite$Params } from '../fn/registration/get-site';
import { getSites } from '../fn/registration/get-sites';
import { GetSites$Params } from '../fn/registration/get-sites';
import { postConfirmEmail } from '../fn/registration/post-confirm-email';
import { PostConfirmEmail$Params } from '../fn/registration/post-confirm-email';
import { postEnsureEmailValidity } from '../fn/registration/post-ensure-email-validity';
import { PostEnsureEmailValidity$Params } from '../fn/registration/post-ensure-email-validity';
import { postEnsureEmailValidityWithSso } from '../fn/registration/post-ensure-email-validity-with-sso';
import { PostEnsureEmailValidityWithSso$Params } from '../fn/registration/post-ensure-email-validity-with-sso';
import { postRegister } from '../fn/registration/post-register';
import { PostRegister$Params } from '../fn/registration/post-register';
import { postSendConfirmEmail } from '../fn/registration/post-send-confirm-email';
import { PostSendConfirmEmail$Params } from '../fn/registration/post-send-confirm-email';
import { postUnregister } from '../fn/registration/post-unregister';
import { PostUnregister$Params } from '../fn/registration/post-unregister';
import { RegisterResult } from '../models/register-result';

@Injectable({ providedIn: 'root' })
export class ApiRegistrationService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postRegistrationConfirmEmail()` */
  static readonly PostRegistrationConfirmEmailPath = '/Registration/confirm-email';

  /**
   * post-registration-confirm-email.
   *
   * Confirm email<br>Check is email is confirmed
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postConfirmEmail()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postConfirmEmail$Response(params?: PostConfirmEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postConfirmEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * post-registration-confirm-email.
   *
   * Confirm email<br>Check is email is confirmed
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postConfirmEmail$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postConfirmEmail(params?: PostConfirmEmail$Params, context?: HttpContext): Observable<void> {
    return this.postConfirmEmail$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `postRegistrationEnsureEmailValidity()` */
  static readonly PostRegistrationEnsureEmailValidityPath = '/Registration/ensure-email-validity';

  /**
   * post-registration-ensure-email-validity.
   *
   * Ensure Email Validity<br>Email is valid if it's not duplicate nor outside domain validation
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postEnsureEmailValidity()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postEnsureEmailValidity$Response(params?: PostEnsureEmailValidity$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return postEnsureEmailValidity(this.http, this.rootUrl, params, context);
  }

  /**
   * post-registration-ensure-email-validity.
   *
   * Ensure Email Validity<br>Email is valid if it's not duplicate nor outside domain validation
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postEnsureEmailValidity$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postEnsureEmailValidity(params?: PostEnsureEmailValidity$Params, context?: HttpContext): Observable<boolean> {
    return this.postEnsureEmailValidity$Response(params, context).pipe(map((r: StrictHttpResponse<boolean>): boolean => r.body));
  }

  /** Path part for operation `postRegistrationEnsureEmailValidityWithSso()` */
  static readonly PostRegistrationEnsureEmailValidityWithSsoPath = '/Registration/ensure-email-validity-with-sso';

  /**
   * post-registration-ensure-email-validity-with-sso.
   *
   * Ensure Email Validity (with SSO)<br>Validates the email (not duplicate, matches domain policy) and initiates a SAML SSO flow when applicable.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postEnsureEmailValidityWithSso()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postEnsureEmailValidityWithSso$Response(
    params?: PostEnsureEmailValidityWithSso$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<EnsureEmailValidityWithSsoResult>> {
    return postEnsureEmailValidityWithSso(this.http, this.rootUrl, params, context);
  }

  /**
   * post-registration-ensure-email-validity-with-sso.
   *
   * Ensure Email Validity (with SSO)<br>Validates the email (not duplicate, matches domain policy) and initiates a SAML SSO flow when applicable.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postEnsureEmailValidityWithSso$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postEnsureEmailValidityWithSso(params?: PostEnsureEmailValidityWithSso$Params, context?: HttpContext): Observable<EnsureEmailValidityWithSsoResult> {
    return this.postEnsureEmailValidityWithSso$Response(params, context).pipe(
      map((r: StrictHttpResponse<EnsureEmailValidityWithSsoResult>): EnsureEmailValidityWithSsoResult => r.body),
    );
  }

  /** Path part for operation `getRegistrationSite()` */
  static readonly GetRegistrationSitePath = '/Registration/site';

  /**
   * get-registration-site.
   *
   * Get Registration Site<br>Get the site registration informations corresponding to request params
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSite()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSite$Response(params?: GetSite$Params, context?: HttpContext): Observable<StrictHttpResponse<GetRegistrationSiteResult>> {
    return getSite(this.http, this.rootUrl, params, context);
  }

  /**
   * get-registration-site.
   *
   * Get Registration Site<br>Get the site registration informations corresponding to request params
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSite$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSite(params?: GetSite$Params, context?: HttpContext): Observable<GetRegistrationSiteResult> {
    return this.getSite$Response(params, context).pipe(map((r: StrictHttpResponse<GetRegistrationSiteResult>): GetRegistrationSiteResult => r.body));
  }

  /** Path part for operation `getRegistrationSites()` */
  static readonly GetRegistrationSitesPath = '/Registration/sites';

  /**
   * get-registration-sites.
   *
   * Get Registration Sites<br>Get all site registration informations corresponding to request params
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSites()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSites$Response(params?: GetSites$Params, context?: HttpContext): Observable<StrictHttpResponse<GetRegistrationSitesResult>> {
    return getSites(this.http, this.rootUrl, params, context);
  }

  /**
   * get-registration-sites.
   *
   * Get Registration Sites<br>Get all site registration informations corresponding to request params
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSites$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSites(params?: GetSites$Params, context?: HttpContext): Observable<GetRegistrationSitesResult> {
    return this.getSites$Response(params, context).pipe(map((r: StrictHttpResponse<GetRegistrationSitesResult>): GetRegistrationSitesResult => r.body));
  }

  /** Path part for operation `postRegistrationRegister()` */
  static readonly PostRegistrationRegisterPath = '/Registration/register';

  /**
   * post-registration-register.
   *
   * User Register
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postRegister()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postRegister$Response(params?: PostRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisterResult>> {
    return postRegister(this.http, this.rootUrl, params, context);
  }

  /**
   * post-registration-register.
   *
   * User Register
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postRegister$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postRegister(params?: PostRegister$Params, context?: HttpContext): Observable<RegisterResult> {
    return this.postRegister$Response(params, context).pipe(map((r: StrictHttpResponse<RegisterResult>): RegisterResult => r.body));
  }

  /** Path part for operation `postRegistrationSendConfirmEmail()` */
  static readonly PostRegistrationSendConfirmEmailPath = '/Registration/send-confirm-email';

  /**
   * post-registration-send-confirm-email.
   *
   * Send confirm email<br>Send email to finalize registration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postSendConfirmEmail()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postSendConfirmEmail$Response(params?: PostSendConfirmEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postSendConfirmEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * post-registration-send-confirm-email.
   *
   * Send confirm email<br>Send email to finalize registration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postSendConfirmEmail$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postSendConfirmEmail(params?: PostSendConfirmEmail$Params, context?: HttpContext): Observable<void> {
    return this.postSendConfirmEmail$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `postRegistrationUnregister()` */
  static readonly PostRegistrationUnregisterPath = '/Registration/unregister';

  /**
   * post-registration-unregister.
   *
   * User unregister
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUnregister()` instead.
   *
   * This method doesn't expect any request body.
   */
  postUnregister$Response(params?: PostUnregister$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return postUnregister(this.http, this.rootUrl, params, context);
  }

  /**
   * post-registration-unregister.
   *
   * User unregister
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUnregister$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postUnregister(params?: PostUnregister$Params, context?: HttpContext): Observable<boolean> {
    return this.postUnregister$Response(params, context).pipe(map((r: StrictHttpResponse<boolean>): boolean => r.body));
  }
}
